import useSWR from 'swr'
import {fetcher} from '../services/http.service'
import {GetShippingInfoResponse} from './apiTypes'
import {useEffect} from 'react'
import {queries} from "./queries";
import {useNavigate} from "react-router-dom";

export function useShippingInfo(tracking_number?: string) {
    const navigate = useNavigate();
    const {data, error, isLoading, mutate} = useSWR<GetShippingInfoResponse>(
        !!tracking_number?queries.shipping.info(tracking_number):null,
        fetcher,
        {revalidateIfStale: false, revalidateOnFocus: false, revalidateOnReconnect: false}
    )

    useEffect(() => {
        if (error && error?.response?.status === 404) {
            navigate("/404", {replace: true});
        }
    }, [error, navigate])

    console.log('useShippingInfo', data)
    return {
        shipping: data,
        isLoading,
        mutate,
        isError: error,
    }
}
